import { connect } from 'react-redux';

import AssignmentComments from '../../../../commonComponents/Modals/AssignmentComments/AssignmentComments';
import { createAssignmentComment } from '../../actionsSagas';
import {
  getAddingAssignmentComment,
  getAssignmentCommentError,
  getAssignmentComments,
} from '../../selectors';

const mapStateToProps = (state, ownProps) => ({
  comments: getAssignmentComments(state, ownProps.assignment.id),
  saving: getAddingAssignmentComment(state),
  error: getAssignmentCommentError(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onAddComment: (comment) =>
    dispatch(createAssignmentComment(ownProps.assignment.id, comment)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssignmentComments);
